import { render, staticRenderFns } from "./TableInsertButton.vue?vue&type=template&id=283800c8&scoped=true&"
import script from "./TableInsertButton.vue?vue&type=script&lang=js&"
export * from "./TableInsertButton.vue?vue&type=script&lang=js&"
import style0 from "./TableInsertButton.vue?vue&type=style&index=0&id=283800c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283800c8",
  null
  
)

export default component.exports